var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterVolums({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_747_3394)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3C2 2.44771 2.44771 2 3 2H13C13.5523 2 14 2.44771 14 3V4.39053C14 4.74415 13.8595 5.08329 13.6095 5.33333L10 8.9428V13.8921C10 14.4373 9.42633 14.7919 8.93873 14.5481L6.46065 13.309C6.17833 13.1679 6 12.8793 6 12.5637V8.9428L2.39053 5.33333C2.14047 5.08329 2 4.74415 2 4.39053V3Z",
    fill: "#889096"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_747_3394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterVolums);
export default __webpack_public_path__ + "static/media/filter_volums.30c0fa92b2e3e2794d34228885e0faee.svg";
export { ForwardRef as ReactComponent };